<template>
  <div id="category-navigation-bar" class="category-navigation-bar">
    <!-- Mobile -->
    <div class="d-md-none p-1">
      <b-select
        v-model="selectedOption"
        :options="selectOptions"
        @change="handleMobileSelect">
      </b-select>
    </div>
    <b-navbar
      type="light"
      variant="white"
      class="p-1 category-navigation-bar__bar d-none d-md-block">
      <b-container class="category-navigation-bar__container">
        <b-navbar-nav class="category-navigation-bar__bar-nav" justified>
          <b-nav-item
            to="/listings"
            class="category-navigation-item">
            browse
          </b-nav-item>
          <b-nav-item-dropdown
            v-for="category in categories"
            href="#"
            class="category-navigation-item"
            :key="category.slug"
            no-caret>
            <template v-slot:button-content>
              <span class="text-dark">
                {{category.name.toLowerCase()}}
              </span>
            </template>
            <b-dropdown-item
              :to="`/listings?category=${category.slug}`">
              all {{category.name.toLowerCase()}}
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item
              v-for="subcategory in category.subcategories"
              :key="subcategory.slug"
              :to="`/listings?category=${category.slug}&subcategory=${subcategory.slug}`"
              href="#">
              {{subcategory.name.toLowerCase()}}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'CategoryBar',
  data() {
    return {
      selectedOption: null,
      categories: [],
    }
  },
  computed: {
    selectOptions() {
      if (!this.categories.length) return []
      return [{
        value: null,
        text: 'Browse listing categories',
      }].concat(
        this.categories
          .map(category => ({
            label: category.name,
            options: category.subcategories.map(subcategory => ({
              value: {
                category: category.slug,
                subcategory: subcategory.slug,
                link: `/listings?category=${category.slug}&subcategory=${subcategory.slug}`,
              },
              text: subcategory.name,
            })).concat([
              {
                value: {
                  category: category.slug,
                  subcategory: null,
                  link: `/listings?category=${category.slug}`,
                },
                text: `All listings in ${category.name}`,
              },
            ]),
          })),
      )
    },
  },
  methods: {
    handleMobileSelect(value) {
      if (value && value.link) {
        this.$router.push(value.link)
      }
    },
  },
  async created() {
    const persistedCategories = localStorage.getItem('zooplocal:categories')

    if (persistedCategories) {
      try {
        const { expires, categories } = JSON.parse(persistedCategories)
        if (expires > Date.now()) {
          this.categories = categories
          return
        }
      } catch (err) {
        console.error(err)
      }
    }

    const { data: { categories } } = await this.$http.get('/categories')
    this.categories = categories

    localStorage.setItem('zooplocal:categories', JSON.stringify({
      expires: Date.now() + (1000 * 60 * 60 * 24),
      categories,
    }))
  },
}
</script>

<style lang="scss">
.category-navigation-bar {
  border-bottom: 1px solid #E9E9E9;
}

.category-navigation-bar__bar {
  position: relative;
  padding: 0;
  max-width: 100%;
}

.category-navigation-bar__container {
  width: 100%;
}

.category-navigation-bar__bar-nav {
  width: 100%;
}

.navbar {
  padding: 0;
}
</style>
